import styled from '@emotion/styled'
import { ProgramBox, ProgramContent, ProgramStack, ProgramText, ProgramTitle } from 'planby'

export interface StyledChannelLogoProps {
    isEnded: boolean
    isLive: boolean
    backgroundColor: string
}
export const StyledProgramContent = styled(ProgramContent)<StyledChannelLogoProps>(
    ({ isEnded, theme, isLive, backgroundColor }) => ({
        borderRadius: 0,
        background: isLive ? backgroundColor + '33' : theme.eventBox.primary,
        padding: '8px 15px',
        '&:hover': {
            background: isLive ? backgroundColor + '4d' : theme.eventBox.primaryHover,
        },
        opacity: isEnded ? 0.6 : 'unset',
        textAlign: 'start',
        transition: 'all 0.3s ease-in-out',
        '@media(min-width: 768px)': {
            padding: '10px 15px',
        },
    }),
)

export const StyledEmptyProgramContent = styled('div')(({ theme }) => ({
    borderRadius: 0,
    background: theme.eventBox.fillerBackground,
    padding: '8px 15px',
    '&:hover': {
        background: theme.eventBox.fillerBackground,
    },
    opacity: 'unset',
    textAlign: 'start',
    '@media(min-width: 768px)': {
        padding: '10px 15px',
    },
    height: '100%',
}))

export const StyledProgramBox = styled(ProgramBox)(() => ({
    padding: '2px',
    paddingTop: '2px',
    paddingBottom: '3px',
    a: {
        textDecoration: 'none',
    },
}))

export const StyledProgramStack = styled(ProgramStack)(() => ({
    overflow: 'visible',
}))

export const StyledProgramTime = styled('span')(({ theme }) => ({
    fontWeight: 600,
    color: theme.eventBox.text,
    fontSize: '10px',
    textTransform: 'lowercase',
    '@media(min-width: 768px)': {
        fontSize: '11px',
    },
}))

export const StyledProgramRating = styled('span')(({ theme }) => ({
    color: theme.eventBox.textDescription,
    fontSize: '10px',
    marginLeft: '7px',
    fontWeight: 600,
    '@media(min-width: 768px)': {
        fontSize: '11px',
    },
}))

export const StyledProgramTitle = styled(ProgramTitle)(({ theme }) => ({
    fontWeight: 600,
    color: theme.eventBox.text,
    marginBottom: '5px',
    fontSize: '12px',
    '@media(min-width: 768px)': {
        fontSize: '13px',
        marginBottom: '8px',
    },
}))

export const StyledProgramFillerTitle = styled(ProgramTitle)(({ theme }) => ({
    fontWeight: 600,
    color: theme.eventBox.fillerText,
    fontSize: '12px',
    '@media(min-width: 768px)': {
        fontSize: '13px',
        marginBottom: '8px',
    },
}))

export const StyledProgramDescription = styled(ProgramText)(({ theme }) => ({
    color: theme.eventBox.textDescription,
    whiteSpace: 'normal',
    display: '-webkit-box',
    lineClamp: 2,
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    fontSize: '11px',
    marginTop: '7px',
    '@media(min-width: 768px)': {
        marginTop: '9px',
    },
}))

export const StyledLiveText = styled('span')(() => ({
    fontSize: '10px',
    marginRight: '6px',
    fontWeight: 600,
    '@media(min-width: 768px)': {
        fontSize: '11px',
    },
}))

export const StyledInfoIcon = styled('img')({
    marginLeft: '14px',
    height: '18px',
    position: 'absolute',
    top: '5px',
    '@media(min-width: 768px)': {
        top: '7px',
    },
})
